import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/index';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import NavigatedDataReducer from './reducers/NavigatedDataReducer';

// Configuration for redux-persist
const persistConfig = {
  key: 'root',
  storage,
  // Optional: use whitelist or blacklist here
  whitelist: ['navigate'], // Only persist specified reducers
  // blacklist: ['temporaryReducer'], // Do not persist specified reducers
};

// Wrap the root reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
const store = configureStore({
  reducer: persistedReducer,
  devTools: window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
});

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };
